import React from "react";
import { useTranslation } from 'react-i18next';

function AccountReviewPage(props){

    var { t } = useTranslation();

    return(
        <div>
            <div className="uk-container uk-margin-small-top">
                {/** */}
            </div>
        </div>
    );
}

export default AccountReviewPage;